module.exports = __webpack_public_path__ + "nc_static/media/service_contract_edit.dc14885a.svg";